export const processedSample = {
    "asset": "historic placeholder",
    "asset_id": "aaa-bbb-ccc-ddd-eee-fff",
    "forecast_issued": "2024-08-28 09:39 UTC",
    "processedModels": "historic",
    "description": "historic data source placeholder",
    "models": {
        "historic": {
            "variation": "historic",
            "graphType": "scatter",
            "yUnit": "",
            "data": {}
        }
    }
}